<template>
  <div>
    <a-form-model 
      ref="ruleForm"
      :model="form"  
      :rules="rules" 
      :label-col="labelCol"
      :wrapper-col="wrapperCol">
      <a-form-model-item label="配方代码: " ref="code" prop="code" :style="{display: noneOrblock}">
        <a-input v-model="form.code" disabled/>
      </a-form-model-item>
      <a-form-model-item label="配方版本: " ref="version" prop="version" :style="{display: noneOrblock}">
        <a-input v-model="form.version" disabled/>
      </a-form-model-item>
      <a-form-model-item label="配方名称: " ref="name" prop="name">
        <a-input v-model="form.name" 
        @blur="
          () => {
            $refs.name.onFieldBlur();
          }" />
      </a-form-model-item>
      
      <a-form-model-item label="动物类型: " ref="one" prop="one">
        <a-select
          class="search_content_class"
          v-model="form.one"
          label-in-value
          :default-value="{ key: '请选择' }"
        >
          <a-select-option v-for="(lo) in list" v-bind:key="lo.key" v-bind:value="lo">
            {{lo}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="配方模型: " ref="two" prop="two">
        <a-select
          class="search_content_class"
          v-model="form.two"
          label-in-value
          :default-value="{ key: '请选择' }"
        >
          <a-select-option v-for="(lo) in list" v-bind:key="lo.key" v-bind:value="lo">
            {{lo}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="价格来源: " ref="three" prop="three">
        <a-select
          class="search_content_class"
          v-model="form.three"
          label-in-value
          :default-value="{ key: '请选择' }"
        >
          <a-select-option v-for="(lo) in list" v-bind:key="lo.key" v-bind:value="lo">
            {{lo}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设定盘重: " ref="number1" prop="number1">
        <div class="model_item_input_class">
          <a-input-number class="model_item_input_number_class"/>
          <a-input value="KG" disabled class="model_item_input_unit_class"/>
        </div>
      </a-form-model-item>
      <a-form-model-item label="分析基础:" ref="number2" prop="number2">
        <div class="model_item_input_class">
          <a-input value="1.000" disabled class="model_item_input_number_class"/>
          <a-input value="KG" disabled class="model_item_input_unit_class"/>
        </div>
      </a-form-model-item>
      
      <a-form-model-item label="备注: ">
        <a-input v-model="form.desc" type="textarea"/>
      </a-form-model-item>
    </a-form-model>
    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button @click="onCancelHandle">取消</a-button>
      <a-button @click="onSubmitHandle">确定</a-button>
    </a-form-model-item>
  </div>
</template>

<script>
export default {
  props: ['noneOrblock'],

  data(){
    return {
      // noneOrblock: 'none', //'inline-block'
      form: {
        name: '',
        region: undefined,
        date1: undefined,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
          // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' },
        ],
        one: [{ required: true, message: '请选择动物类型', trigger: 'change' }],
        two: [{ required: true, message: '请选择配方模型', trigger: 'change' }],
        three: [{ required: true, message: '请选择价格来源', trigger: 'change' }],
        number1: [{ required: true, trigger: 'change' }],
        number2: [{ required: true, trigger: 'change' }],
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    }
  },
  methods: {
    onSubmitHandle() {
      this.$refs.ruleForm.validate(valid => {
        console.log('error submit!!', valid);

        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // resetForm() {
    //   this.$refs.ruleForm.resetFields();
    // },
  }
}
</script>

<style lang="scss" scoped>
.model_item_input_class {
  display: flex;
  .model_item_input_number_class {
    width: 100px;
    margin-right: 10px;
  }
  .model_item_input_unit_class {
    flex: 1;

  }
}
</style>